import React from 'react';
import { DataGrid } from "@mui/x-data-grid";

const GlobalIaaC = (props) => {
  console.log("GlobalIaaC props=", props);
  const { subscriptions } = props.iaac;
  const rows = [
    {
      id: 'Price',
      basic: subscriptions.find(sub => sub.subscription === 'Basic').price,
      standard: subscriptions.find(sub => sub.subscription === 'Standard').price,
      premium: subscriptions.find(sub => sub.subscription === 'Premium').price,
      enterprise: "Contact us"
    },
    {
      id: 'Limit',
      basic: subscriptions.find(sub => sub.subscription === 'Basic').limit,
      standard: subscriptions.find(sub => sub.subscription === 'Standard').limit,
      premium: subscriptions.find(sub => sub.subscription === 'Premium').limit,
      enterprise: "Contact us"
    },
  ];

  const columns = [
    {
      field: "id",
      headerName: "",
      width: 180,
      sortable: false,
      renderCell: (rowData) => {
        // if (rowData.row.id === "enabled") {
        //   return null;
        // }
        if (rowData.row.id === "Price") {
          return (
            <>
              Price (<small style={{ color: "red" }}>Billed Monthly</small>)
            </>
          );
        }
      },
    },
    {
      field: "basic",
      headerName: "Basic",
      width: 140,
      sortable: false,
      disableClickEventBubbling: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "standard",
      headerName: "Standard",
      width: 140,
      sortable: false,
      disableClickEventBubbling: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "premium",
      headerName: "Premium",
      width: 140,
      sortable: false,
      disableClickEventBubbling: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "enterprise",
      headerName: "Enterprise",
      width: 140,
      sortable: false,
      disableClickEventBubbling: true,
      align: "center",
      headerAlign: "center",
    },
  ];

  return (
    <div
      style={{ justifyContent: "center", display: "flex", flexWrap: "wrap" }}
    >
      <DataGrid
        getRowId={(row) => row.id}
        rows={rows}
        // rows={[]}
        columns={columns}
        pageSize={5}
        disableSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
        disableColumnReorder
        disableMultipleColumnsSorting
        disableMultipleColumnsFiltering
        hideFooterPagination
        autoHeight
        hideFooter
        rowHeight={40}
      />
    </div>
  )
}

export default GlobalIaaC;